import React from "react";
import styled from "styled-components";

import OutfitMenuItem from "./OutfitMenuItem";

const OutfitModalMenu = (props: any) => {
  const { className, recommendation, children } = props;
  return (
    <Wrapper className={className}>
      {recommendation.map((item: any, i: number) => (
        <OutfitMenuItem key={item.id} className={"item"} {...item} />
      ))}
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  font-family: HelveticaNeue-Medium;
  color: #060606;
`;

const Block = styled.div`
  width: 100%;
  background: blue;
  height: 300px;
  margin: 2rem 0;
`;

export default OutfitModalMenu;
